import request from './api'

export async function syncAllDogs(periodS, periodPo) {
    try {
        const res = await request('/api/account/sync-all-dogs', 'POST', {
            period_s: periodS,
            period_po: periodPo,
        })
        return {
            isOk: true,
            message: res?.message,
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
        }
    }
}
